<div class="row dashboardBlock">
  <div class="col-12">
    <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
      <div class="col-sm-2 col-md-3 padding-menu">
        <div class="executionList">
          <ul>
            <ng-container *ngFor="let item of monitoringList; let i = index">
              <li *ngIf="item.isShow"
                [ngClass]="item.isActive ? (isArabic ? 'active arabicAlign' : 'active') : (isArabic ? 'cursor-pointer arabicAlign' : 'cursor-pointer')"
                (click)="onListItemClick(i)">
                <span class="stepNumber">
                  <img [src]="item.img" alt="" />
                </span>
                <span class="stepText" *ngIf="!isArabic">{{ item.value }}</span>
                <span class="stepText" *ngIf="isArabic">{{ item.arabicValue }}</span>
                <div *ngIf="item.link == 'monitoring/resubmit' && rejectedAssessmentsCount>0" class="rejectedCount"
                  [ngClass]="isArabic ? 'arabicCount' : ''">{{rejectedAssessmentsCount}}</div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="col-sm-10 col-md-9 assessment-right">
        <div><router-outlet (activate)="subscribeToEmitter($event)"></router-outlet></div>
        <div class="startBtnDiv" [ngClass]="isArabic ? 'col-md-4' : 'offset-md-8 col-md-4'">
          <button type="submit" class="btn-lg btn-primary ratButton rightBtn nextButton"
            [ngClass]="(assessment == null || assessment == undefined) ? 'disabledBtn' : ''"
            (click)="goToGeneralAssessment()" [disabled]="assessment == null || assessment == undefined">
            <ng-container *ngIf="!ifResubmitAssesment">
              <ng-container *ngIf="!isAssessmentStarted">
                <span *ngIf="!isArabic">START REVIEW</span>
                <span *ngIf="isArabic">ابدأ المراجعة</span>
              </ng-container>
              <ng-container *ngIf="isAssessmentStarted">
                <span *ngIf="!isArabic">CONTINUE REVIEW</span>
                <span *ngIf="isArabic">متابعة الاستعراض</span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="ifResubmitAssesment">
              <span *ngIf="!isArabic">RESUBMIT ASSESSMENT</span>
              <span *ngIf="isArabic">إعادة تسليم التقييم</span>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>